import {
  ListGroup,
  ListItem,
} from "@avinet/adaptive-ui-core/form/controls/List";

export enum ContentType {
  group = "group",
  layer = "layer",
}

export enum SourceType {
  adaptive = "adaptive",
  osm = "osm",
  wms = "wms",
  wmts = "wmts",
}

interface BaseContent {
  type: ContentType;
  id?: string;
  enabled: boolean;
}

interface BaseLayerContent extends BaseContent {
  type: ContentType.layer;
  sourceType: SourceType;
  title: string;
  description?: string;
}

export interface AdaptiveLayerContent extends BaseLayerContent {
  sourceType: SourceType.adaptive;
  themeType: "theme" | "digitheme" | "basetheme";
  themeUuid: string;
}

export interface OsmLayerContent extends BaseLayerContent {
  sourceType: SourceType.osm;
  opacity?: number;
}

export interface WmsLayerContent extends BaseLayerContent {
  sourceType: SourceType.wms;
  uri: string;
  layers: string;
  format: string;
  params?: { [key: string]: any };
  version?: "1.1.0" | "1.1.1" | "1.3.0";
  /** If true, the WMS layer is a single tile layer (Image WMS) */
  single?: boolean;
  opacity?: number;
  minZoom?: number;
  maxZoom?: number;
}

export interface WmtsLayerContent extends BaseLayerContent {
  sourceType: SourceType.wmts;
  uri: string;
  format: string;
  layers: string;
  matrixSet: string;
  layerStyle: string;
  matrixIds: string[];
  numberOfZoomResolutions: number;
  opacity?: number;
  minZoom?: number;
  maxZoom?: number;
}

export interface GroupContent extends BaseContent {
  type: ContentType.group;
  children: Content[];
}

export type LayerContent =
  | AdaptiveLayerContent
  | OsmLayerContent
  | WmsLayerContent
  | WmtsLayerContent;
export type Content = GroupContent | LayerContent;

export const sourceGroups: ListGroup[] = [{ group: "layer" }];

export const sourceTypes: ListItem[] = [
  ...Object.values(SourceType).map((value) => ({
    value,
    group: "layer",
  })),
];
